import React, { useEffect, useContext, useState, useRef } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import {
  Box,
  Button,
} from '@material-ui/core';

import SuperAdminContext from "../../../contexts/SuperAdminContext"

import TopBar from "../../../components/ui/Admin/TopBar"

import EcoleForm from '../../../components/ui/Admin/Ecoles/EcoleForm'


const Ecole = () => {
  const navigate = useNavigate()
  const params = useParams();

  const { ecoles } = useContext(SuperAdminContext)

  const [ecole, setEcole] = useState(null)
  const [hasChanged, setHasChanged] = useState(false)

  const setActEcole = () => {
    var findEcole = ecoles?.find((l) => l.id.toString() == params?.id)

    if (findEcole) {
      //if (ecole == null) {
        setEcole(findEcole)
      //}
    } else {
      navigate("/admin/ecoles")
    }
  }

  useEffect(() => {
    if (params?.id && ecoles) {
      setActEcole()
    }
  }, [ecoles, ecole, params])


  return (
    <>
      <Helmet>
        <title>Admin Ecoles | TheLab</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.grey',
          minHeight: '100%',
          py: 0,
          display:"flex",
          flexDirection:"column",
        }}
      >
        <Box
          sx={{
            flex:1,
            padding:"20px",
            backgroundColor:"background.grey",
          }}
        >
          <TopBar
            withBack="/admin/ecoles"
            title="Edition d'une École"
          >
            <Button
              variant="contained"
              sx={{ minHeight:"35px !important" }}
              disabled={!hasChanged}
              onClick={() => {
                document.getElementById('hidden_form_submit').click()
              }}
            >
              Éditer l'école
            </Button>
          </TopBar>


          {ecole !== null && (
            <EcoleForm
              isEdit={true}
              ecole={ecole}
              setHasChanged={setHasChanged}
            />
          )}

        </Box>
      </Box>
    </>
  )
};

export default Ecole;
